import React, { Suspense, useState, useEffect, useRef } from "react";
import { Modal } from 'react-responsive-modal';
import Pagination from "components/Common/newPagination";
import { format } from "date-fns";
import DeleteDialogueBox from "../Common/deleteDialogue";
import ClientProfileSevices from "./clientProfileServices";

export default function CurrentJobs(param: any) {

    let [deleteJob, setDelete] = useState(0);
    const [showtab, setShowTab] = useState(1);
    var dataLink = "pageSize=10&pageNumber=1";
    const [totalRows, setTotalRows] = useState(1);
    let [jobIdDelete, SetJobIdDelete] = useState(1);
    let [deleteMessage, setDeleteMessage] = useState('');
    const [openFirst, setOpenFirst] = React.useState(false);
    const [currentList, initCurrentlist] = useState<any[]>([]);

    const Data: any = {
        pageSize: 10,
        pageNumber: 1,
        totalRows: 0
    }

    const handleNameOnChange = (n: any) => {
        Data.pageNumber = n.pageNumber;
        Data.pageSize = n.pageSize;
        dataLink = 'pageSize=' + Data.pageSize + '&pageNumber=' + Data.pageNumber;
        currentPage(showtab)
    }

    const currentPage = (e: number) => {
        setShowTab(e);

        if (searchFor.length > 0) {
            dataLink = dataLink + "&searchFor=" + searchFor
        }
        if (e === 1) {
            ClientProfileSevices.CurrentJobs(dataLink).then((res) => {
                initCurrentlist(res)
                if (res.length < 1) { setTotalRows(0) }
                else { setTotalRows(res[0].totalRows); }
            })
        }

        if (e === 2) {

            ClientProfileSevices.AsynchronousJobs(dataLink).then((res) => {
                initCurrentlist(res)
                if (res.length < 1) { setTotalRows(0) }
                else { setTotalRows(res[0].totalRows); }
            })
        }

        if (e === 3) {
            ClientProfileSevices.EmailStatementJobs(dataLink).then((res) => {
                initCurrentlist(res)
                setTotalRows(res[0].totalRows);
            })
        }
    }

    const Export = (param: any) => {
        console.log("data")
        ClientProfileSevices.CurrentJobsExport(param);
    }

    const Refresh = (e: any) => {
        dataLink = 'pageSize=10&pageNumber=1';
        Data.pageNumber = 1;
        Data.pageSize = 10;
        handleNameOnChange(Data);

    }

    const Confirmation = (e: any) => {
        if (e === 1) {
            if (showtab === 1) {
                ClientProfileSevices.CurrentJobsClear({ "include": "1|2", jobId: '' });
            }

            if (showtab === 2 && deleteMessage === 'cancel this SQL job') {
                ClientProfileSevices.sqlJobDelete({ jobId: jobIdDelete });
            }

            if (showtab === 3) {
                ClientProfileSevices.CurrentJobsClear({ "include": "3", jobId: '' });
            }
        }
        setDelete(0);
        Refresh(showtab);
    }

    const sqlJobDelete = (e: any) => {
        jobIdDelete = e;
        SetJobIdDelete(jobIdDelete);

        deleteJob = 1
        setDeleteMessage("cancel this SQL job")
        setDelete(deleteJob)
    }

    const [searchFor, setSearchFor] = useState("");

    return (
        <>
            <div className={param.type !== "calculation" && param.type !== "button" ? "box-primary ms text-center iconLogo pull-left  mrl" : "hide"}>
                <i className="box icon-tag2" onClick={() => { setOpenFirst(true); currentPage(showtab); }}></i>
                <span className="m0 pts ">Job Status</span>
            </div>

            <div className={param.type === "calculation" ? "box-primary prx pts  pull-right  mrl "+param.css : "hide"}>
                <a className={"white text-underline " +param.css} onClick={() => { setOpenFirst(true); currentPage(showtab); }}>Job Status</a>
            </div>

            <button className={param.type === "button" ? "icon-btn info width150 height30 "+param.css : "hide"} onClick={() => { setOpenFirst(true); currentPage(showtab); }}>
                Job Status
            </button>


            <Modal open={openFirst} onClose={() => setOpenFirst(false)} center>

                <div className="box full-height">
                    <div className="box-content full-height">

                        <div className="ws-12 ptl pbl">
                            {/*   <ul className="nav nav-tabs nav-justified mbl">
                                <li id="1" className={showtab === 1 ? "btn active" : "btn "} onClick={() => currentPage(1)}> Current Job </li>
                                <li id="2" className={showtab === 2 ? "btn active" : "btn "} onClick={() => currentPage(2)}> Asynchronous Job </li>
                                <li id="3" className={showtab === 3 ? "btn active" : "btn "} onClick={() => currentPage(3)}> Email Statement Job  </li>
                            </ul> */}


                            <div className="ws-5">

                                <a id="1" className={showtab === 1 ? "icon-btn edit fill" : "icon-btn edit "} onClick={() => currentPage(1)}> Current Job </a>
                                <a id="2" className={showtab === 2 ? "icon-btn edit fill" : "icon-btn edit "} onClick={() => currentPage(2)}> Asynchronous Job </a>
                                <a id="3" className={showtab === 3 ? "icon-btn edit fill" : "icon-btn edit "} onClick={() => currentPage(3)}> Email Statement Job  </a>
                            </div>

                            <div className="ws-4">
                                <button className="btn white bg-level7 text-center p8 m0 pull-right ws-3" onClick={() => currentPage(showtab)}> Search</button>
                                <input type="text" placeholder="Type to search" value={searchFor} onChange={(e: any) => setSearchFor(e.target.value)}
                                    className="p7 ws-8 heightReset border-green pull-right" />
                            </div>
                        </div>


                        <div className="box">
                            <div className="box-header well">
                                <h2 className="pull-left "><i className="fa fa-tasks"></i>
                                    {showtab === 1 ? "Current Jobs Status" : showtab === 2 ? "Asynchronous Job Status" : "Email Statement Status"}({totalRows})</h2>
                                <div className="pull-right"><button className="icon-btn delete pull-right" onClick={() => Refresh(showtab)}>
                                    <i className="icon-refresh1"></i></button>
                                </div>
                            </div>
                            {
                                (() => {

                                    if (totalRows > 0) {
                                        return (

                                            <>
                                                {<div className="box-content">

                                                    {(showtab === 1 || showtab === 3) && <table className="table bgWhite tablePresentation ">
                                                        <thead>
                                                            <tr>
                                                                <th>Time</th>
                                                                <th>Name</th>
                                                                <th>Date Created</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>

                                                            {currentList.map(post => (
                                                                <tr>
                                                                    <td>{post?.timeEntered} </td>
                                                                    <td> {post?.actionCompleted}</td>
                                                                    <td>{format(new Date(post?.dateCreated), 'MMM dd, yyyy')} </td>
                                                                </tr>

                                                            ))}

                                                        </tbody>
                                                    </table>}

                                                    {showtab === 2 && <table className="table table-bordered">
                                                        <thead>
                                                            <tr>
                                                                <th >Job ID</th>
                                                                <th >Description</th>
                                                                <th >Status</th>
                                                                <th >Operation</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>

                                                            {currentList?.map((value: any) => (

                                                                <tr className={value.status === 'Not Executing' ? 'info' : 'bg-success'}>
                                                                    <td><span >{value.jobId}</span></td>
                                                                    <td><span >{value.description}</span></td>
                                                                    <td><span >{value.status}</span></td>
                                                                    <td>
                                                                        <a onClick={() => sqlJobDelete(value.jobId)} className="icon-btn delete"><i className="icon-trashcan"></i></a>
                                                                    </td>
                                                                </tr>
                                                            )
                                                            )}
                                                        </tbody>
                                                    </table>}

                                                </div>}

                                                {
                                                    (() => {
                                                        if (totalRows > 1 && totalRows > 10) {
                                                            return <div className="pll ml"> <Pagination onPageChange={handleNameOnChange} totalRow={totalRows} /></div>
                                                        }

                                                    })()
                                                }

                                                <div className=" ws-12 pull-right">
                                                    {showtab !== 2 && <button className="icon-btn info  width130 pull-right" onClick={() => { setDelete(1); setDeleteMessage("all Job") }}>Clear All Jobs</button>}
                                                    {showtab === 1 && <button className="icon-btn edit btn-sm  width130 pull-right" onClick={() => Export("1|2")}><i className="fa fa-download"></i> Export All Jobs</button>}
                                                    {showtab === 3 && <button className="icon-btn edit btn-sm  width130 pull-right" onClick={() => Export("3")}><i className="fa fa-download"></i> Export All Jobs</button>}
                                                    {showtab === 5 && <button className="icon-btn edit btn-sm  width130 pull-right" onClick={() => Export("1|2")}><i className="fa fa-download"></i> Export All Jobs</button>}
                                                    <button className="icon-btn delete btn-sm width130 pull-right" onClick={() => setOpenFirst(false)}> Close</button>
                                                </div>
                                            </>

                                        )
                                    } else {
                                        return (
                                            <div className="box ptl pLarge">
                                                {showtab === 1 && <span className="alert alert-success ws-12 text-center ptl">No sql jobs running</span>}
                                                {showtab === 2 && <span className="alert alert-success ws-12 text-center">No current jobs available</span>}
                                                {showtab === 3 && <span className="alert alert-success ws-12 text-center">No email statement record</span>}
                                            </div>
                                        )
                                    }
                                })()
                            }

                            {
                                (() => {
                                    if (deleteJob && deleteJob === 1) {
                                        return <DeleteDialogueBox param={true} message={deleteMessage} onChange={Confirmation} />
                                    }
                                })()
                            }
                        </div>
                    </div>
                </div>

            </Modal>

        </>
    )
}